import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import API from 'services/api';
import get from 'lodash/get';
import {
  taskTypeActions,
  taskTypeFilterActions,
  taskTypeNameSpace,
  taskTypeSelectors,
} from 'containers/Pages/Tasks/TaskTypes';

export function* fetchTaskTypeListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const { data } = yield call(API.fetchTaskTypes, { ...filters, from });
    if (data.data != null) {
      const totalEntries = get(data, 'meta.total');
      yield put(taskTypeActions.setGridList({ list: data.data, totalEntries }));
    }
    yield put(taskTypeFilterActions.setFilterKey(false));
    yield put(taskTypeActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* fetchTaskTypeDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    //select from the state
    const rows = yield select(taskTypeSelectors.getTaskTypeListRaw);
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(taskTypeActions.setGridRowDetails({ details: value }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* createOrUpdateTaskTypeSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { taskType } = payload;
    //transform the item
    const data = {
      data: {
        id: taskType.id,
        category: taskType.category.id,
        categoryIcon: taskType.category.icon,
        typeName: taskType.name,
        qualificationRequired: false, // will be implemented when the user can be given a qualification
        archived: taskType.archived,
      },
    };
    const { status } = yield call(API.updateTaskType, data);
    if (status === 200) {
      yield put(toggleModal(taskTypeNameSpace));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* taskTypeSagas() {
  yield takeLatest(taskTypeActions.fetchGridList, fetchTaskTypeListSaga);
  yield takeLatest(
    taskTypeActions.fetchGridRowDetails,
    fetchTaskTypeDetailsSaga,
  );
  yield takeLatest(taskTypeActions.createRowEntry, createOrUpdateTaskTypeSaga);
  yield takeLatest(taskTypeActions.updateRowEntry, createOrUpdateTaskTypeSaga);
}
